import { NavBar } from 'components/NavBar/NavBar'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Pagination } from 'components/Pagination/Pagination'
import { Td } from 'components/Td/Td'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { ColoredDot, Flex, H1WithBack, PageFooter, PageWrapper, Table, TableFuelLevelIndicator, Th, Tr } from 'styling/GlobalStyles'
import { getParams, handleMachineStatus, handlePagination } from 'utils/helpers'
import { clearFuelMachines, getFuelMachines } from 'features/fuelManagement/fuelManagementSlice'
import { OtherText } from 'styling/Typography'
import { HealthySensorIcon } from '../icons/HealthySensorIcon'
import { NotInstalledSensorIcon } from '../icons/NotInstalledSensorIcon'
import { ErrorSensorIcon } from '../icons/ErrorSensorIcon'

export const FuelMachines = () => {
    const { machines } = useSelector((store: RootState) => store.fuelManagement)
    const [params, setParams] = useState<any>(getParams({ location }))

    useQueryPagination({ fetchFunctions: [getFuelMachines], cleanUpFunctions: [clearFuelMachines], params })

    function formatDate(date) {
        date = new Date(date)
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        const day = date.getDate();
        const month = months[date.getMonth()];

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${day} ${month}, ${hours}:${minutes}`;
    }

    return <>
        <NavBar />
        <PageWrapper>
            <H1WithBack mb='1' title='Equipment Fuel Statuses' arrow />
            {!machines?.data?.length ? (
                <NoItems title='Machines' />
            ) : (
                <Table width='100%' >
                    <Th >
                        <Td w='12.5%' noTooltip text='NAME' />
                        <Td w='15%' noTooltip text='MODEL' />
                        <Td w='17.5%' noTooltip text='FUEL LEVEL' />
                        <Td w='10%' noTooltip text='AVG CONSUMPTION' />
                        <Td w='10%' noTooltip text='TREND' />
                        <Td w='12.5%' noTooltip text='FUEL SENSOR' />
                        <Td w='10%' noTooltip text='LAST REFILL' />
                        <Td w='10%' noTooltip text='STATUS' />

                    </Th>
                    {machines?.data.map((item) => {
                        return (
                            <Tr small key={item.id}>
                                <Td w='12.5%' text={item?.name} />
                                <Td w='15%' text={(item?.machineryModel?.name)} />
                                {/* <Td w='12.5%' text={(item?.machineryModel?.name) + ' ' + (item.vehicle?.almaksVehicle ? item.vehicle?.almaksVehicle?.name : item?.vehicle?.develonVehicle ? item?.vehicle?.develonVehicle?.OEMName : item?.vehicle?.frotcomVehicle ? item?.vehicle?.frotcomVehicle?.licensePlate : '/')} /> */}
                                <Td w='17.5%' >
                                    <Flex width='100%' center between gap='10px'>
                                        <OtherText style={{ flex: 1, }} >{!item.fuelAmount ? 'N/A' : item.fuelAmount.toFixed(1) + ' L'}</OtherText>
                                        <TableFuelLevelIndicator percentage={!item.fuelPercentage ? 0 : item.fuelPercentage} />
                                        <OtherText style={{ flex: 1, textAlign: 'end' }} >{!item.fuelPercentage ? 'N/A' : item.fuelPercentage.toFixed(1) + ' %'}</OtherText>
                                    </Flex>
                                </Td>
                                <Td w='10%' text={item.averageFuelConsumptionAmount ? item.averageFuelConsumptionAmount + (item.usageType == 1 ? ' L/H' : 'L/100km') : 'N/A'} />
                                <Td w='10%'>
                                    {item.fuelConsumptionTrendStatus ? <OtherText style={{ color: item.fuelConsumptionTrendStatus == 1 ? '#FF6B6B' : item.fuelConsumptionTrendStatus == 2 ? '#51CF66' : '#fff' }} >
                                        {item.fuelConsumptionTrendStatus == 1 ? '↑' : item.fuelConsumptionTrendStatus == 2 ? '↓' : '→'} {item.fuelConsumptionTrendPercent} %
                                    </OtherText> : <OtherText>/</OtherText>}
                                </Td>
                                <Td w='12.5%'>
                                    {item.fuelSensorStatus ? <Flex center gap='0.5rem' >
                                        {item.fuelSensorStatus == 1 ? <NotInstalledSensorIcon /> : item.fuelSensorStatus == 2 ? <HealthySensorIcon /> : <ErrorSensorIcon />}
                                        {item.fuelSensorStatus == 1 ? <OtherText style={{ color: '#FF6B6B' }} >Not Installed</OtherText> : item.fuelSensorStatus == 2 ? <OtherText style={{ color: '#51CF66' }} >Healthy</OtherText> : <OtherText style={{ color: '#FF9900' }} >Error</OtherText>}
                                    </Flex> : <OtherText>/</OtherText>}
                                </Td>
                                <Td w='10%' text={item.lastRefillDate ? formatDate(item.lastRefillDate) : '/'} />
                                <Td w='10%'>
                                    <Flex center gap='0.5rem' >
                                        <ColoredDot color={item.status == 1 ? '#51CF66' : item.status == 3 ? '#FF6B6B' : '#FF9900'} />
                                        <OtherText style={{ color: item.status == 1 ? '#51CF66' : item.status == 3 ? '#FF6B6B' : '#FF9900' }} >{handleMachineStatus(item.status)}</OtherText>
                                    </Flex>
                                </Td>
                            </Tr>
                        )
                    })}
                </Table>
            )}
        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(machines?.totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}